import styled from "styled-components";

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 7px;
  transition: background-color 0.2s;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
    fill: ${({ theme }) => theme.darkGrey};
    transition: fill 0.2s;
  }

  &:hover {
    background-color: ${({ theme }) => theme.subtleHover};

    svg {
      fill: ${({ theme }) => theme.primary};
    }
  }
`;
